import { useCallback, useEffect, useState } from "react";
import ElementCard from "../../components/elementCard/ElementCard.component";
import NewTermForm from "../newTermForm/NewTermForm";
import Box from "@mui/material/Box";
import Response_TermsPage from "../../types/responses/Response.TermsPage.type";
import Response_Term from "../../types/responses/Response.Term.type";
import classes from "./TermCardList.module.css";
import PreviousNext from "../../components/previousNext/PreviousNext.component";
import LaButton from "../../components/button/LaButton.component";
import LaModal from "../../components/modal/LaModal.component";
import { getRecentlyAddedTerms } from "../../commons/Api";
import LaSpinner from "../../components/spinner/LaSpinner.component";
import PageTitle from "../../components/pageTitle/PageTitle.component";
import { handleErrorRouting } from "../../commons/LaUtils";
import { getAuthToken } from "../../commons/AuthTokenUtils";
import { useNavigate } from "react-router";
import { ATTR_REDIRECT } from "../../commons/LaConstants";
import { AiOutlinePlus } from "react-icons/ai";
import { COLOR_BNAVY } from "../../commons/LaColors";
import illustration from "../../assets/illustration.svg";

// TODO-adi: refactor; repeated in search results
export enum TermCardList_Type {
  recentlyAddedTerms,
}

const TermCardList = () => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState<Response_TermsPage>();
  const [isSent, setIsSent] = useState(false);

  const handleClose = () => {
    if (!isSent) {
      const result = window.confirm(
        "Are you sure you want to discard the new term changes?",
      );
      if (result) {
        setShow(false);
      }
    } else {
      setShow(false);
    }
  };

  const handleShow = () => {
    setShow(true);
    setIsSent(false);
  };

  const [loading, setLoading] = useState(true);
  const [nextPage, setNextPage] = useState<string | undefined>(undefined);

  const navigate = useNavigate();

  let title = "Recently added terms";

  const token = getAuthToken();

  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    console.error(event);
    return (event.returnValue = "");
  };

  useEffect(() => {
    if (show) {
      window.addEventListener("beforeunload", handleBeforeUnload, {
        capture: true,
      });
    }
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload, {
        capture: true,
      });
    };
  }, [show]);

  const getData = useCallback(
    (_orderedBy: string | undefined, page: string | undefined) => {
      setLoading(true);

      getRecentlyAddedTerms(page, undefined)
        .then((response) => {
          setData(response.data);
          setNextPage(
            response.data.nextPage === null
              ? undefined
              : response.data.nextPage,
          );
        })
        .catch((error) => {
          handleErrorRouting(error, (url: string) => navigate(url));
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [navigate],
  );

  useEffect(() => {
    getData(undefined, undefined);
    window.scrollTo({ top: 0, left: 0 });
  }, [getData]);

  return (
    <div className="row max-width">
      {loading && data === undefined ? (
        <Box>
          <LaSpinner />
        </Box>
      ) : (
        <>
          <div className="col-md-6 ps-md-0">
            <div
              className={`${classes.termCardListSubHeader} flex-column flex-md-row`}
            >
              <PageTitle title={title} />
              <LaButton
                onClick={() => {
                  if (!token) {
                    navigate(
                      "/user/login?" + ATTR_REDIRECT + "=/recentlyAdded",
                    );
                  }
                  handleShow();
                }}
                children={
                  <>
                    <AiOutlinePlus color={COLOR_BNAVY} size={20} /> Add a new
                    term
                  </>
                }
                laStyle="btn-yellow"
              />
            </div>
            {data !== undefined &&
              data.terms.map((term: Response_Term) => {
                return (
                  <ElementCard
                    key={term.id}
                    termId={term.id}
                    termName={term.name}
                    termCreatedOn={term.createdOn}
                    termLastUpdatedOn={term.lastUpdatedOn}
                    termTotalDefinitionCount={term.totalDefinitionCount}
                    termState={term.state + ""}
                  />
                );
              })}

            <PreviousNext
              nextPage={nextPage}
              getData={getData}
              historyKey="recently-added-terms"
            />

            <LaModal
              show={show}
              onHide={handleClose}
              body={<NewTermForm setIsSent={setIsSent} />}
              backdrop={true}
              title="Add a new term"
            />
          </div>
          <div className="col-md-6 flex-column d-none d-md-flex pl-0">
            <div className={`${classes.illustration} ms-auto`}>
              <img
                src={illustration}
                className="px-0 mx-auto"
                alt="Terms illustration"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TermCardList;
